import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { catchError, map, tap } from 'rxjs/operators'

import { Note } from '@tv3/store/note/note.model'
import { Toaster } from '@tokeet/tv3-platform'
import { NoteForm } from '@tv3/interfaces/forms/note.form'

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  constructor(private http: HttpClient, private toast: Toaster) {}

  create(inquiryId: string, form: NoteForm, silent = false): Observable<Note> {
    const url = `@api/inquiry/note/${inquiryId}`

    return this.http.put<object>(url, form).pipe(
      map(Note.deserialize),
      tap(() => {
        if (!silent) {
          this.toast.success('Note added successfully!')
        }
      })
    )
  }

  update(inquiryId: string, note: Note, form: NoteForm): Observable<Note> {
    const url = `@api/inquiry/note/update/${inquiryId}`

    const request = { ...note.serialize(), note: form.note }

    return this.http.put<object>(url, request).pipe(
      map(Note.deserialize),
      tap(() => this.toast.success('Note updated successfully!')),
      catchError(() => throwError({ error: 'Unable to update note' }))
    )
  }

  delete(inquiryId: string, note: Note): Observable<Note> {
    const url = `@api/inquiry/note/delete/${inquiryId}`

    return this.http.put<object>(url, note.serialize()).pipe(
      map(Note.deserialize),
      tap(() => this.toast.success('Note deleted successfully!')),
      catchError(() => throwError({ error: 'Unable to delete note' }))
    )
  }
}
